import React from "react";

import { Space } from "antd";
import { Container } from "./styles";
import ProjectCountByStatus from "./ProjectCountByStatus";
import ConcludedProjectsStats from "./ConcludedProjectsStats";
import ConsultantsProductivityStats from "./ConsultantsProductivityStats";
import InTimeOutdatedProjectsStats from "./InTimeOutdatedProjectsStats";
import AllocationRectability from "./AllocationRectability";
import FactoryRectability from "./FactoryRectability";
import CustomersHoursFactory from "./CustomersHoursFactory";

const Dashboards: React.FC = () => {
  return (
    <Container>
      <Space direction="vertical" size="middle" style={{ display: "flex" }}>
        <InTimeOutdatedProjectsStats />
        <ProjectCountByStatus />
        <ConcludedProjectsStats />
        <ConsultantsProductivityStats />
        <CustomersHoursFactory />
        <AllocationRectability />
        <FactoryRectability />
      </Space>
    </Container>
  );
};

export default Dashboards;
